import React from 'react';
import styled from 'styled-components';
import FieldSettingCard from './FieldSettingCard';
import FancyButton from '../../../knisotLines/Components/FancyButton';
import { FieldSettingEditState, FieldPermissionKey, UserRoleKey } from '../types';
import { getRoleDisplayName } from '../helpers/fieldHelpers';
import CustomBlockLoader from '../../../knisot/generic/CustomBlockLoader';

type Props = {
  fields: FieldSettingEditState[];
  onChange: (fieldId: number, key: FieldPermissionKey, value: boolean | null) => void;
  onSave: () => void;
  isLoading: boolean;
  hasDirtyFields: boolean;
  isVisible: boolean;
  selectedRole: UserRoleKey | null;
};

const FieldSettingsList: React.FC<Props> = ({
  fields,
  onChange,
  onSave,
  isLoading,
  hasDirtyFields,
  isVisible,
  selectedRole,
}) => {
  if (!isVisible) return null;

  const roleLabel = selectedRole ? getRoleDisplayName(selectedRole) : '';

  return (
    <ColumnWrapper>
      <TitleWrapper>
        הגדרות שדות — {roleLabel}
      </TitleWrapper>
      {
        isLoading ? <CustomBlockLoader /> : (
          <ListWrapper>
            {fields.map((field) => (
              <FieldSettingCard
                key={field.fieldId}
                field={field}
                onChange={onChange}
              />
            ))}
          </ListWrapper>
        )
      }
      <ButtonRow>
        <FancyButton
          onClick={onSave}
          isLoading={isLoading}
          disabled={!hasDirtyFields}
        >
          שמור
        </FancyButton>
      </ButtonRow>
    </ColumnWrapper>
  );
};

export default FieldSettingsList;

const ColumnWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 1em;
  padding: 0.75em;
  background: var(--bg-light, #f5f7fa);
  border-radius: 25px 3px 3px 25px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75em 1em;
  font-weight: 600;
  font-size: 1.1em;
  color: var(--primary-green, #297f76);
  font-family: 'Assistant', sans-serif;
  line-height: 1;
`;

const ListWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  gap: 0.75em;
  padding: 0.75em 1em;
  background: var(--bg-white, #ffffff);
  border-radius: 12px;
  overflow-y: auto;
  box-shadow: 0 1px 3px var(--shadow-light, rgba(0, 0, 0, 0.06));
  &::-webkit-scrollbar {
    width: 0;
  }
  scrollbar-width: none;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5em;
`;
